import service from './index'

/**
 * 左侧导航数据
 */
let getLeftNav = () => service.get('/Web/NodeGroup/get_menus');

/**
 * 当前权限所能查看到的所有场馆列表名
 */
let getBuseList = () => service.get('/Web/Business/get_bus_list');

let getAdminBusList = () => service.get('/Web/MemberList/getAdminBusList');
/**
 * 当前商家下的所有场馆列表
 */
let getMerchBuseList = () => service.get('/Web/Card/get_merchants_bus_list');


// 会员详情里的会员卡操作，获取会员卡信息
let getcardInfo = (postData) => service.post('/Web/Member/get_card_user_general_info',postData);

// 会员卡选择
let getCards = (belongBusId) => service.get('/Web/Member/get_card?belong_bus_id=' + (belongBusId || ''));

/**
*获取场馆获客来源
*请求参数：source_type(1:获客来源 2:体培顾问成交方式 3:私教课成交方式，不传都会返回) 编辑卡时传card_user_id,编辑会员时传user_id
*/
let getSources = (postData) => service.post('/Web/Member/get_source',postData);

/**
*销售人员选择
*/
let getSales = (postData) => service.post('/Web/Member/get_sale',postData);

/**
*获取当前卡片支持的场馆列表
*/
let getSupportBus = (cardId) => service.get('/Web/Card/get_support_bus/card_id/' + cardId)

/**
 * 教练列表
 * type: 0所有 1私教 2泳教
 */
let getcoachsInfo = (belongBusId, contain_deleted, type) =>
  service.get(
    "/Web/Member/get_coach?belong_bus_id=" +
      (belongBusId || "") +
      "&contain_deleted=" +
      (contain_deleted || "") +
      "&type=" +
      (type || "")
  );
let getcoachsInfoCopy = (belongBusId, clubId) =>
  service.get(
    "/Web/Member/get_coach?belong_bus_id=" +
      (belongBusId || "") +
      "&club_id=" +
      (clubId || "")
  );

/**
 * 私教教练列表
 */
export const getPtCoachList = (belongBusId) => {
  return service.get('/Web/Member/get_all_private_coach_list?belong_bus_id=' + (belongBusId || ''))
};
export const getPtCoachListCopy = (belongBusId, clubId, cardId) => {
  return service.get('/Web/Member/get_all_private_coach_list?belong_bus_id=' + (belongBusId || '') + '&club_id=' + (clubId || '') + '&card_id=' + (cardId || ''))
};

/**
 * 会籍列表
 */
let getsalesInfo = (belongBusId) => service.get('/Web/Member/get_sale?belong_bus_id=' + (belongBusId || ''));
export let getsalesInfoCopy = (belongBusId, clubId) => service.get('/Web/Member/get_sale?belong_bus_id=' + (belongBusId || '') + '&club_id=' + (clubId || ''));

/**
 * 员工-教练-教练职位
 */
export const coachPosition = () => service.get('/Web/Coach/get_coach_posi')

/**
 * 员工-会籍-会籍职位
 */
export const membershipPosition = () => service.get('/Web/Marketers/get_all_marketers_type')

/**
 * 员工-教练-教练分组
 */
export const coachGroup = () => service.get('/Web/CoachGroup/get_coach_group')

// 教练分组成员列表
export const coachGroupList = () => service.post('/Web/Statistics/coach_group_list')
// 泳教分组成员列表
export const swimGroupList = () => service.post('/Web/Statistics/coach_group_list', {is_swimming_coach: true})

/**
 * 员工-会籍-会籍分组
 */
export const membershipGroup = () => service.get('/Web/MarketersGroup/get_marketers_group')

/**
 * 场馆-场馆详情
 */
export const gymInfo = () => service.post('/Web/Business/get_bus_info')

// 会员卡列表卡选择
export const getMemberListCards = (belongBusId) => service.get('Web/Member/get_card?member_list=1&belong_bus_id=' + (belongBusId || ''));
/**
 * 账号信息
 */
export const adminInfo = () => service.post('/Web/Admin/getAccountDetails')

export const receiptAuthInfo = () => service.post('/Web/SmallTicket/check_admin_print')
/**
 * 导出日志
 */
export const postExportLog = (postData) => service.post('/Web/Public/excel_export_log', postData)

export const inventoryList = (postData) => service.post('/web/inventory/inventoryList', postData);

export const catList = (postData) => service.post('/web/comCate/cateList', postData);

export const getCanEditFields = postData => service.post('/Web/Member/getCanEditFields', postData);
/**
 * 评价回复
 */
export const addFirstReply = (postData)  => service.post('/web/course_comment/addFirstReply', postData);
/**
 * 获取私教课评价详情
 */
export const queryEvaluationDetail = (postData)  => service.post('/web/course_comment/getDetailBySignLogId', postData);

/**
 * 获取私教课评价详情
 */
export const editRefundAmount = (postData)  => service.get('/Web/SpaceOrder/edit_refund_amount');

export { getLeftNav, getBuseList, getAdminBusList, getMerchBuseList, getcardInfo, getCards, getSources, getSales, getSupportBus, getcoachsInfo, getcoachsInfoCopy, getsalesInfo }
